import { FIREBASE_AI_TASKS_SUCCESS, FIREBASE_AI_TASKS_ERROR } from '../../actions/TodoManipulation/aiTasksToFirebaseAction';

const initialState = {
    data: [],
    isLoading: false,
    error: null,
};

const aiTasksToFirebaseReducer = (state = initialState, action) => {

    switch (action.type) {
        case FIREBASE_AI_TASKS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload,
            };
        case FIREBASE_AI_TASKS_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default aiTasksToFirebaseReducer;